import { render, staticRenderFns } from "./DeallocateLimit.vue?vue&type=template&id=165d0d5e&scoped=true"
import script from "./DeallocateLimit.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeallocateLimit.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DeallocateLimit.vue?vue&type=style&index=0&id=165d0d5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165d0d5e",
  null
  
)

export default component.exports